<div class="card-body">
	<div class="row">
		<div class="col form-group">
			<label for="start" class="form-label">Fecha inicio:</label>
			<input type="date" name="start" id="start" (change)="updateChart()" [(ngModel)]="start"
				class="form-control">
		</div>
		<div class="col form-group">
			<label for="end" class="form-label">Fecha final:</label>
			<input type="date" name="end" id="end" (change)="updateChart()" [(ngModel)]="end" class="form-control">
		</div>
		<div class="col form-group">
			<label for="warehouse" class="form-label">
				Bodega:
			</label>
			<select name="warehouse" id="warehouse" (change)="updateChart()" class="form-select"
				[(ngModel)]="warehouse">
				<option [ngValue]="null">General
				</option>
				<option *ngIf="warehouse === undefined && warehouse !== null" [ngValue]="undefined">Selecciona una
					bodega</option>
				<option *ngFor="let w of warehouses" [ngValue]="w.id">{{w.name}}</option>
			</select>
		</div>
	</div>

	<div class="relative-graph" style="min-height: 350px;">
		<div id="provider-inventory-establishment"></div>
		<div class="absolute-loading" *ngIf="loadingChart">
			<span class="display-5 text-center">
				<app-loading-animation [height]="'3rem'"></app-loading-animation>
				Cargando...
			</span>
		</div>
		<div class="absolute-loading" *ngIf="!loadingChart && results.length == 0">
			<span class="display-5 text-center">
				<div class="empty-icon-container">
					<div class="empty-icon-animation">
						<i class="fa-solid fa-exclamation"></i>
					</div>
					<i class="fa fa-box-open"></i>
				</div>
				No se cuenta con registros
			</span>
		</div>
	</div>

</div>